/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */




export const MeetingDayDto = {
    Yesterday: 'YESTERDAY',
    Today: 'TODAY',
    Tomorrow: 'TOMORROW'
} as const;

export type MeetingDayDto = typeof MeetingDayDto[keyof typeof MeetingDayDto];



